import { useTranslations } from "next-intl";
import { useQuery } from "@apollo/client";
import {
  Task,
  TaskOverviewByFormResultIdDocument,
} from "@quales/data-access/gql-server";
import React from "react";
import TaskCard from "./TaskCard";
import { TaskContext } from "@quales/utils/context";
import { WcIcon, WcPaper, WcStack, WcTypography } from "@bpipartners/webui";
import { PiListChecks } from "react-icons/pi";
import { useTheme } from "@quales/utils/theme";

interface MultiContextTaskOverviewProps {
  formResultID: string | string[];
}

export const MultiContextTaskOverview = ({
  formResultID,
}: MultiContextTaskOverviewProps) => {
  const t = useTranslations();
  const theme = useTheme();
  const {
    handleUpdateFormResultID,
    onTaskAction,
    onOpenTaskSideSheet,
    onTaskID,
  } = React.useContext(TaskContext);
  const [tasks, setTasks] = React.useState<Task[]>([]);
  const { data, loading } = useQuery(TaskOverviewByFormResultIdDocument, {
    variables: {
      //@ts-ignore
      formResultID: formResultID.toString(),
    },
    fetchPolicy: "network-only",
  });

  const handleTaskClick = (inputTask: Task) => {
    if (inputTask) {
      handleUpdateFormResultID(formResultID.toString());
    }
    onOpenTaskSideSheet();
    onTaskID(inputTask.taskID.toString());
    onTaskAction(2);
  };

  React.useEffect(() => {
    if (
      !loading &&
      data &&
      data.TaskOverviewByFormResultID &&
      data.TaskOverviewByFormResultID.length > 0
    ) {
      setTasks(data.TaskOverviewByFormResultID);
    } else {
      setTasks([]);
    }
  }, [data, loading]);

  return (
    <WcPaper id="MultiContextTaskOverview" sx={{ spacing: 4, padding: 8 }}>
      <WcStack
        direction={"row"}
        spacing={2}
        alignItems={"center"}
        paddingBottom={4}
      >
        <WcIcon>
          <PiListChecks color={theme.appColors.secondary} />
        </WcIcon>
        <WcTypography variant="h6">{t("common.taskList")}</WcTypography>
      </WcStack>
      <WcStack spacing={8}>
        {tasks &&
          tasks.length > 0 &&
          tasks.map((task, index) => (
            <TaskCard
              key={task.taskID.toString() + index.toString()}
              task={task}
              onCardClick={handleTaskClick}
            />
          ))}
      </WcStack>
      {tasks && tasks.length === 0 && (
        <WcTypography variant="subtitle2">{t("common.noData")}</WcTypography>
      )}
    </WcPaper>
  );
};

export default MultiContextTaskOverview;
